import { Reducer } from 'redux'
import { createFilter } from 'redux-persist-transform-filter'

import { ApprovalsActionTypes, ApprovalsState } from './types'

export const FILTER_PERSISTOR = createFilter(
  'approvals',
  null,
  ['filterStatus'],
  'whitelist'
)

const INITIAL_STATE: ApprovalsState = {
  error: '',
  filterStatus: [],
  list: [],
  loading: false,
  reloading: false,
  setStatusError: '',
  setStatusLoading: false,
  setStatusSuccess: '',
  total_results: 0
}

const reducer: Reducer<ApprovalsState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    /**
     * GET_APPROVALS
     */
    case ApprovalsActionTypes.GET_APPROVALS:
      return {
        ...state,
        filterStatus: payload.options.filterStatus,
        error: '',
        loading: !payload.options.reload,
        reloading: payload.options.reload
      }
    case ApprovalsActionTypes.GET_APPROVALS_SUCCESS:
      return {
        ...state,
        list: payload.list,
        loading: false,
        reloading: false,
        total_results: payload.total_results
      }
    case ApprovalsActionTypes.GET_APPROVALS_FAILURE:
      return {
        ...state,
        error: payload.message,
        loading: false,
        reloading: false
      }

    /**
     * SET_APPROVAL_STATUS
     */
    case ApprovalsActionTypes.SET_APPROVAL_STATUS:
      return {
        ...state,
        setStatusError: '',
        setStatusLoading: true,
        setStatusSuccess: ''
      }
    case ApprovalsActionTypes.SET_APPROVAL_STATUS_SUCCESS:
      return {
        ...state,
        setStatusLoading: false,
        setStatusSuccess: payload.message
      }
    case ApprovalsActionTypes.SET_APPROVAL_STATUS_FAILURE:
      return {
        ...state,
        setStatusError: payload.message,
        setStatusLoading: false
      }

    default:
      return state
  }
}

export default reducer
